import { Injectable } from "@angular/core";

@Injectable()
export class MultiTenancyService {
    getTenantIdCookie(): string | string[] {
        return "Default";
    }
    isEnabled: boolean;
    tenantIdCookieName = 'Abp.TenantId'
}